/**
 * Supplier (Taminotchi) Zod sxemalar — mahsulot yetkazib beruvchi.
 *
 * Har bir taminotchi bitta kategoriyani ta'minlaydi. Kategoriya ichidagi
 * mahsulotlarning stok'i `minStock` dan past tushsa, yetishmovchilik
 * ro'yxatiga tushadi va telegram orqali yuboriladi (botsiz, share link).
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
// ─── Field schemalar ──────────────────────────────────────────────
const nameSchema = z
    .string()
    .trim()
    .min(1, 'Taminotchi nomi kerak')
    .max(150, 'Nom 150 belgidan oshmasligi kerak');
const phoneSchema = z
    .string()
    .trim()
    .max(30, 'Raqam 30 belgidan oshmasligi kerak')
    .nullable()
    .optional();
const telegramSchema = z
    .string()
    .trim()
    .max(100, 'Telegram nomi 100 belgidan oshmasligi kerak')
    .nullable()
    .optional();
const noteSchema = z
    .string()
    .trim()
    .max(500, 'Izoh 500 belgidan oshmasligi kerak')
    .nullable()
    .optional();
const minStockSchema = z
    .number()
    .int("Butun son bo'lishi kerak")
    .min(1, "Minimal soni 1 dan kam bo'lmaydi")
    .max(1_000_000, 'Juda katta son');
// ─── Create ───────────────────────────────────────────────────────
export const createSupplierSchema = z.object({
    name: nameSchema,
    phone: phoneSchema,
    telegram: telegramSchema,
    note: noteSchema,
    minStock: minStockSchema.default(10),
    categoryId: uuidSchema,
});
// ─── Update (partial) ─────────────────────────────────────────────
export const updateSupplierSchema = z.object({
    name: nameSchema.optional(),
    phone: phoneSchema,
    telegram: telegramSchema,
    note: noteSchema,
    minStock: minStockSchema.optional(),
    categoryId: uuidSchema.optional(),
});
//# sourceMappingURL=supplier.schema.js.map